/**
 * FEEDBACK (C1) — o quadrante de uma avaliação. UMA função, para o painel, o selo e o PDF (o servidor importa daqui).
 *
 * A regra é a do sistema antigo (`anexos/feedback-conteudo.json`, `quadrante.mapa`), aprovada pelo Matheus em 05/10 para
 * a grade 3x3 Desempenho × Valores: as 4 pontas com nome próprio, e as 5 casas com algum "Médio" — ou com Desempenho ou
 * Valores vazio — como Zona Neutra. 🔴 O grupo é calculado na hora e NUNCA guardado (decisão de 05/10). O Impacto da
 * saída não entra no grupo: ele é um selo à parte.
 */

export type Nivel = 'Baixo' | 'Médio' | 'Alto';
export const NIVEIS: readonly Nivel[] = ['Alto', 'Médio', 'Baixo'];

export type ChaveDoQuadrante = 'delegar' | 'redirecionar' | 'desenvolver' | 'desligar' | 'neutro';

/** Os 5 grupos, na ordem dos cartões do painel. Rótulos literais do sistema antigo. */
export const GRUPOS: ReadonlyArray<{ chave: ChaveDoQuadrante; rotulo: string }> = [
  { chave: 'delegar', rotulo: 'Delegar Desafios' },
  { chave: 'redirecionar', rotulo: 'Redirecionar' },
  { chave: 'desenvolver', rotulo: 'Desenvolver' },
  { chave: 'desligar', rotulo: 'Desligar' },
  { chave: 'neutro', rotulo: 'Zona Neutra' },
];

/** `desempenho` × `valores` → o grupo. */
export function quadranteDe(desempenho: Nivel | null | undefined, valores: Nivel | null | undefined): ChaveDoQuadrante {
  if (desempenho === 'Alto' && valores === 'Alto') return 'delegar';
  if (desempenho === 'Alto' && valores === 'Baixo') return 'redirecionar';
  if (desempenho === 'Baixo' && valores === 'Alto') return 'desenvolver';
  if (desempenho === 'Baixo' && valores === 'Baixo') return 'desligar';
  return 'neutro';
}

export function rotuloDoQuadrante(chave: ChaveDoQuadrante): string {
  return GRUPOS.find((g) => g.chave === chave)!.rotulo;
}
